import React from 'react';
import dayjs from 'dayjs';

import { Flex } from 'common';

export interface Props {
  date?: number | null;
  disabled: boolean;
}

export const DateContainer = ({ disabled, date: itemDate }: Props) => {
  const styles = {
    opacity: disabled ? '0.4' : '1.0',
  };

  const date = React.useMemo(() => {
    if (itemDate) {
      const d = dayjs.unix(itemDate);
      return { date: d.format('MM/DD/YYYY'), time: d.format('hh:mm A') };
    }
    return null;
  }, [itemDate]);

  return (
    <Flex flexDirection="column">
      {!date && <p style={styles}>-/-</p>}

      {date && (
        <>
          <p className="elipsis" style={styles}>
            {date.date}
          </p>
          <p className="elipsis" style={styles}>
            {date.time}
          </p>
        </>
      )}
    </Flex>
  );
};
